import React from "react";
import styled, { keyframes } from "styled-components";

const motion = () => keyframes`
  0% {
      transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const RingSpinner = styled.div<{ size: number; sizeUnit: string }>`
  box-sizing: border-box;
  display: inline-block;
  position: absolute;
  width: ${(p) => `${p.size}${p.sizeUnit}`};
  height: ${(p) => `${p.size}${p.sizeUnit}`};
  margin: 0px;
  border: 2px solid ${(p) => p.color};
  border-radius: 50%;
  animation: ${(p) => motion()} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: ${(p) => p.color} transparent transparent transparent;
  :nth-child(1) {
    animation-delay: -0.45s;
  }
  :nth-child(2) {
    animation-delay: -0.3s;
  }
  :nth-child(3) {
    animation-delay: -0.15s;
  }
`;

const Ring = ({
  color,
  size,
  sizeUnit
}: {
  color: string;
  size: number;
  sizeUnit: string;
}) => <RingSpinner color={color} size={size} sizeUnit={sizeUnit} />;

Ring.defaultProps = {
  size: 25,
  color: "#FFFFFF",
  sizeUnit: "rem"
};

export default Ring;
